var _animateMotion, _animate, _animate2, _animate3, _animate4, _g, _g2, _g3, _g4, _animate5, _animate6, _animate7, _animate8, _g5, _animate9, _animate10, _animate11, _animate12, _animate13, _animate14, _clipPath, _g6, _g7, _g8, _g9, _animate15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZweiFaktorAuthentifizierung(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 300 200",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.289342,0.146302,-0.451232,0.892407,761.04,-2166.74)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1561.34,2283.41C1561.34,2282.31 1558.57,2281.41 1555.17,2281.41L1131.51,2281.41C1128.1,2281.41 1125.34,2282.31 1125.34,2283.41C1125.34,2284.52 1128.1,2285.41 1131.51,2285.41L1555.17,2285.41C1558.57,2285.41 1561.34,2284.52 1561.34,2283.41Z",
    style: {
      fill: "rgb(182,182,182)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.285651,-0.127262,0.406956,0.913448,-1192.5,-1787.86)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1561.34,2283.41C1561.34,2282.31 1558.47,2281.41 1554.94,2281.41L1131.73,2281.41C1128.2,2281.41 1125.34,2282.31 1125.34,2283.41C1125.34,2284.52 1128.2,2285.41 1131.73,2285.41L1554.94,2285.41C1558.47,2285.41 1561.34,2284.52 1561.34,2283.41Z",
    style: {
      fill: "rgb(182,182,182)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.000174018,-0.182373,1,-0.00095419,-2241,352.523)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1561.34,2283.41C1561.34,2282.31 1556.42,2281.41 1550.37,2281.41L1136.3,2281.41C1130.25,2281.41 1125.34,2282.31 1125.34,2283.41C1125.34,2284.52 1130.25,2285.41 1136.3,2285.41L1550.37,2285.41C1556.42,2285.41 1561.34,2284.52 1561.34,2283.41Z",
    style: {
      fill: "rgb(182,182,182)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "punkt",
    transform: "matrix(1.00541,0,0,1.02796,-15.9938,-130.537)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.034,
    cy: 124,
    rx: 6.922,
    ry: 6.699,
    style: {
      fill: "rgb(199,199,199)"
    }
  }, _animateMotion || (_animateMotion = /*#__PURE__*/React.createElement("animateMotion", {
    id: "point",
    path: "M59.407,37.492L182.246,99.248L41.89,162.571L42.646,28.173L177.624,97.97",
    dur: "12s",
    begin: "1s; eingeloggt.end + 1s",
    fill: "freeze"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "User-Icon",
    serifId: "User Icon",
    transform: "matrix(2.75812,0,0,2.5143,-495.723,-7372.54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.004,2959.62C201.186,2959.92 199.049,2960 195,2960C190.951,2960 188.814,2959.92 186.996,2959.62C184.451,2959.19 183,2958.28 183,2956.76C183,2954.75 185.592,2951.94 189.196,2950.31C190.652,2952.52 192.709,2954 195,2954C197.291,2954 199.348,2952.52 200.804,2950.31C204.408,2951.94 207,2954.75 207,2956.76C207,2958.28 205.549,2959.19 203.004,2959.62ZM195,2952C191.678,2952 189,2947.59 189,2943.06C189,2938.84 191.505,2936 195,2936C198.495,2936 201,2938.84 201,2943.06C201,2947.59 198.322,2952 195,2952Z",
    style: {
      fill: "rgb(75,75,75)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "laptop",
    transform: "matrix(0.209196,0,0,0.209196,218.548,97.1954)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-217.12,-217.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.97,316.51L277.26,316.51C277.26,331.57 265.05,343.78 249.99,343.78L184.25,343.78C169.19,343.78 156.97,331.57 156.97,316.51Z",
    style: {
      fill: "rgb(102,100,93)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.24,316.51L434.24,349.21C434.24,361.31 424.43,371.12 412.33,371.12L21.91,371.12C9.81,371.12 0,361.31 0,349.21L0,316.51L156.97,316.51C156.97,331.57 169.19,343.78 184.25,343.78L249.99,343.78C265.05,343.78 277.26,331.57 277.26,316.51L434.24,316.51Z",
    style: {
      fill: "rgb(153,153,153)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.08,85.03L418.08,316.51L16.15,316.51L16.15,85.03C16.15,72.93 25.96,63.12 38.06,63.12L396.17,63.12C408.27,63.12 418.08,72.93 418.08,85.03ZM385.32,280.91L385.32,97.42L48.92,97.42L48.92,280.91L385.32,280.91Z",
    style: {
      fill: "rgb(178,177,170)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.32,97.42L385.32,280.91L189.12,280.91L269.97,97.42L385.32,97.42Z",
    style: {
      fill: "rgb(229,150,131)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.97,97.42L189.12,280.91L48.92,280.91L48.92,97.42L269.97,97.42Z",
    style: {
      fill: "rgb(226,186,181)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-32.3627,-14.4908)"
  }, /*#__PURE__*/React.createElement("text", {
    opacity: 1,
    x: "202.564px",
    y: "149.856px",
    style: {
      fontFamily: "'ArialMT', 'Arial', sans-serif",
      fontSize: 30
    }
  }, "LOGIN\n                ", _animate || (_animate = /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1; 1; 1; 1; 1; 1; 1; 1; 0;",
    dur: "3s",
    fill: "freeze",
    begin: "point.begin"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-32.3627,55.0649)"
  }, /*#__PURE__*/React.createElement("text", {
    opacity: 0,
    id: "Eingeloggt",
    x: "150.057px",
    y: "149.856px",
    style: {
      fontFamily: "'ArialMT', 'Arial', sans-serif",
      fontSize: 30
    }
  }, "EINGELOGGT\n                ", _animate2 || (_animate2 = /*#__PURE__*/React.createElement("animate", {
    id: "eingeloggt",
    attributeName: "opacity",
    values: "0; 1; 1; 1; 1; 1; 1;",
    dur: "4s",
    begin: "point.begin + 16s"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-32.8457,24.6343)"
  }, /*#__PURE__*/React.createElement("text", {
    opacity: 0,
    id: "CODE",
    x: "205.904px",
    y: "149.856px",
    style: {
      fontFamily: "'ArialMT', 'Arial', sans-serif",
      fontSize: 30
    }
  }, "CODE\n                ", _animate3 || (_animate3 = /*#__PURE__*/React.createElement("animate", {
    id: "code",
    attributeName: "opacity",
    values: "0; 1; 1; 1; 1; 1; 1;",
    dur: "13s",
    begin: "point.begin + 3s"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-33.3288,62.3103)"
  }, /*#__PURE__*/React.createElement("text", {
    opacity: 0,
    id: "unterstriche",
    x: "190.867px",
    y: "149.856px",
    style: {
      fontFamily: "'ArialMT', 'Arial', sans-serif",
      fontSize: 30
    }
  }, "_ \xA0_ \xA0_ \xA0_\n                ", _animate4 || (_animate4 = /*#__PURE__*/React.createElement("animate", {
    id: "unterstriche",
    attributeName: "opacity",
    values: "0; 1; 1; 1; 1; 1; 1;",
    dur: "13s",
    begin: "point.begin + 3s"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Medical",
    transform: "matrix(0.405743,0,0,0.405743,118.197,-281.639)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0,
    d: "M110.031,1188.34L110.031,1188.39L110.124,1188.39L110.031,1188.34L110.031,1172L119.969,1172L119.969,1188.34L119.876,1188.39L119.969,1188.39L119.969,1188.34L133.17,1180.67L134.03,1180.17L134.527,1181.04L138.502,1187.96L138.999,1188.83L138.138,1189.33L124.937,1197L138.138,1204.67L138.999,1205.17L138.502,1206.04L134.527,1212.96L134.03,1213.83L133.17,1213.33L119.969,1205.66L119.969,1205.61L119.876,1205.61L119.969,1205.66L119.969,1222L110.031,1222L110.031,1205.66L110.124,1205.61L110.031,1205.61L110.031,1205.66L96.83,1213.33L95.97,1213.83L95.473,1212.96L91.498,1206.04L91.001,1205.17L91.862,1204.67L105.063,1197L91.862,1189.33L91.001,1188.83L91.498,1187.96L95.473,1181.04L95.97,1180.17L96.83,1180.67L110.031,1188.34ZM105.063,1197L105.063,1197C105.063,1197 105.063,1197 105.063,1197ZM124.937,1197C124.937,1197 124.937,1197 124.937,1197L124.937,1197Z"
  }, /*#__PURE__*/React.createElement("animate", {
    id: "star",
    attributeName: "opacity",
    values: "0; 1; 1; 1; 1; 1; 1;",
    dur: "4s",
    begin: "point.begin + 12s"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Medical1",
    serifId: "Medical",
    transform: "matrix(0.405743,0,0,0.405743,151.851,-281.473)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0,
    d: "M110.031,1188.34L110.031,1188.39L110.124,1188.39L110.031,1188.34L110.031,1172L119.969,1172L119.969,1188.34L119.876,1188.39L119.969,1188.39L119.969,1188.34L133.17,1180.67L134.03,1180.17L134.527,1181.04L138.502,1187.96L138.999,1188.83L138.138,1189.33L124.937,1197L138.138,1204.67L138.999,1205.17L138.502,1206.04L134.527,1212.96L134.03,1213.83L133.17,1213.33L119.969,1205.66L119.969,1205.61L119.876,1205.61L119.969,1205.66L119.969,1222L110.031,1222L110.031,1205.66L110.124,1205.61L110.031,1205.61L110.031,1205.66L96.83,1213.33L95.97,1213.83L95.473,1212.96L91.498,1206.04L91.001,1205.17L91.862,1204.67L105.063,1197L91.862,1189.33L91.001,1188.83L91.498,1187.96L95.473,1181.04L95.97,1180.17L96.83,1180.67L110.031,1188.34ZM105.063,1197L105.063,1197C105.063,1197 105.063,1197 105.063,1197ZM124.937,1197C124.937,1197 124.937,1197 124.937,1197L124.937,1197Z"
  }, /*#__PURE__*/React.createElement("animate", {
    id: "star2",
    attributeName: "opacity",
    values: "0; 1; 1; 1; 1; 1; 1;",
    dur: "3s",
    begin: "point.begin + 13s"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Medical2",
    serifId: "Medical",
    transform: "matrix(0.405743,0,0,0.405743,184.95,-280.919)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0,
    d: "M110.031,1188.34L110.031,1188.39L110.124,1188.39L110.031,1188.34L110.031,1172L119.969,1172L119.969,1188.34L119.876,1188.39L119.969,1188.39L119.969,1188.34L133.17,1180.67L134.03,1180.17L134.527,1181.04L138.502,1187.96L138.999,1188.83L138.138,1189.33L124.937,1197L138.138,1204.67L138.999,1205.17L138.502,1206.04L134.527,1212.96L134.03,1213.83L133.17,1213.33L119.969,1205.66L119.969,1205.61L119.876,1205.61L119.969,1205.66L119.969,1222L110.031,1222L110.031,1205.66L110.124,1205.61L110.031,1205.61L110.031,1205.66L96.83,1213.33L95.97,1213.83L95.473,1212.96L91.498,1206.04L91.001,1205.17L91.862,1204.67L105.063,1197L91.862,1189.33L91.001,1188.83L91.498,1187.96L95.473,1181.04L95.97,1180.17L96.83,1180.67L110.031,1188.34ZM105.063,1197L105.063,1197C105.063,1197 105.063,1197 105.063,1197ZM124.937,1197C124.937,1197 124.937,1197 124.937,1197L124.937,1197Z"
  }, /*#__PURE__*/React.createElement("animate", {
    id: "star3",
    attributeName: "opacity",
    values: "0; 1; 1; 1; 1; 1; 1;",
    dur: "2s",
    begin: "point.begin + 14s"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Medical3",
    serifId: "Medical",
    transform: "matrix(0.405743,0,0,0.405743,219.474,-280.99)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0,
    d: "M110.031,1188.34L110.031,1188.39L110.124,1188.39L110.031,1188.34L110.031,1172L119.969,1172L119.969,1188.34L119.876,1188.39L119.969,1188.39L119.969,1188.34L133.17,1180.67L134.03,1180.17L134.527,1181.04L138.502,1187.96L138.999,1188.83L138.138,1189.33L124.937,1197L138.138,1204.67L138.999,1205.17L138.502,1206.04L134.527,1212.96L134.03,1213.83L133.17,1213.33L119.969,1205.66L119.969,1205.61L119.876,1205.61L119.969,1205.66L119.969,1222L110.031,1222L110.031,1205.66L110.124,1205.61L110.031,1205.61L110.031,1205.66L96.83,1213.33L95.97,1213.83L95.473,1212.96L91.498,1206.04L91.001,1205.17L91.862,1204.67L105.063,1197L91.862,1189.33L91.001,1188.83L91.498,1187.96L95.473,1181.04L95.97,1180.17L96.83,1180.67L110.031,1188.34ZM105.063,1197L105.063,1197C105.063,1197 105.063,1197 105.063,1197ZM124.937,1197C124.937,1197 124.937,1197 124.937,1197L124.937,1197Z"
  }, /*#__PURE__*/React.createElement("animate", {
    id: "star4",
    attributeName: "opacity",
    values: "0; 1; 1; 1; 1; 1; 1;",
    dur: "1s",
    begin: "point.begin + 15s"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Standard-Button",
    serifId: "Standard Button",
    transform: "matrix(0.604817,0,0,0.604817,-252.612,-319.048)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    id: "Base",
    d: "M854,957.5C854,945.082 843.918,935 831.5,935L720.5,935C708.082,935 698,945.082 698,957.5C698,969.918 708.082,980 720.5,980L831.5,980C843.918,980 854,969.918 854,957.5ZM852.347,957.5C852.347,969.006 843.006,978.347 831.5,978.347L720.5,978.347C708.994,978.347 699.653,969.006 699.653,957.5C699.653,945.994 708.994,936.653 720.5,936.653C720.5,936.653 831.5,936.653 831.5,936.653C843.006,936.653 852.347,945.994 852.347,957.5Z",
    style: {
      fill: "rgb(83,101,125)"
    }
  }, _animate5 || (_animate5 = /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1; 1; 1; 1; 1; 1; 1; 1; 0;",
    dur: "3s",
    fill: "freeze",
    begin: "point.begin"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Standard",
    transform: "matrix(1,0,0,1,775.871,962.676)"
  }, /*#__PURE__*/React.createElement("text", {
    opacity: 1,
    x: "-23.749px",
    y: "0px",
    style: {
      fontFamily: "'Arial-BoldMT', 'Arial', sans-serif",
      fontWeight: 700,
      fontSize: 15
    }
  }, "LOGIN\n                    ", _animate6 || (_animate6 = /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1; 1; 1; 1; 1; 1; 1; 1; 0;",
    dur: "3s",
    fill: "freeze",
    begin: "point.begin"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Base1",
    serifId: "Base",
    transform: "matrix(0.911353,0,0,0.604817,-488.31,-409.373)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    d: "M854,957.5C854,945.082 847.309,935 839.068,935L712.932,935C704.691,935 698,945.082 698,957.5C698,969.918 704.691,980 712.932,980L839.068,980C847.309,980 854,969.918 854,957.5ZM852.903,957.5C852.903,969.006 846.704,978.347 839.068,978.347C839.068,978.347 712.932,978.347 712.932,978.347C705.296,978.347 699.097,969.006 699.097,957.5C699.097,945.994 705.296,936.653 712.932,936.653C712.932,936.653 839.068,936.653 839.068,936.653C846.704,936.653 852.903,945.994 852.903,957.5Z",
    style: {
      fill: "rgb(83,101,125)"
    }
  }, _animate7 || (_animate7 = /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1; 1; 1; 1; 1; 1; 1; 1; 0;",
    dur: "3s",
    fill: "freeze",
    begin: "point.begin"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Base2",
    serifId: "Base",
    transform: "matrix(0.911353,0,0,0.604817,-487.827,-377.494)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    d: "M854,957.5C854,945.082 847.309,935 839.068,935L712.932,935C704.691,935 698,945.082 698,957.5C698,969.918 704.691,980 712.932,980L839.068,980C847.309,980 854,969.918 854,957.5ZM852.903,957.5C852.903,969.006 846.704,978.347 839.068,978.347L712.932,978.347C705.296,978.347 699.097,969.006 699.097,957.5C699.097,945.994 705.296,936.653 712.932,936.653L839.068,936.653C846.704,936.653 852.903,945.994 852.903,957.5Z",
    style: {
      fill: "rgb(83,101,125)"
    }
  }, _animate8 || (_animate8 = /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1; 1; 1; 1; 1; 1; 1; 1; 0;",
    dur: "3s",
    fill: "freeze",
    begin: "point.begin"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Input"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Twitter-Icon",
    serifId: "Twitter Icon",
    transform: "matrix(0.697905,0,0,0.710323,-21.3691,-2490.96)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    d: "M313.539,3822.98C313.548,3823.2 313.551,3823.42 313.551,3823.64C313.551,3830.31 308.602,3838.01 299.552,3838.01C296.772,3838.01 294.187,3837.17 292.009,3835.74C292.394,3835.78 292.785,3835.81 293.182,3835.81C295.487,3835.81 297.61,3835 299.294,3833.64C297.141,3833.61 295.323,3832.14 294.696,3830.14C294.997,3830.2 295.307,3830.23 295.624,3830.23C296.071,3830.23 296.505,3830.17 296.921,3830.05C294.668,3829.59 292.971,3827.55 292.971,3825.1L292.971,3825.04C293.635,3825.41 294.395,3825.64 295.202,3825.67C293.88,3824.76 293.011,3823.21 293.011,3821.46C293.011,3820.54 293.253,3819.67 293.679,3818.92C296.105,3821.98 299.732,3823.99 303.821,3824.2C303.737,3823.83 303.694,3823.44 303.694,3823.05C303.694,3820.26 305.897,3818 308.615,3818C310.03,3818 311.308,3818.61 312.205,3819.59C313.328,3819.37 314.38,3818.95 315.332,3818.37C314.963,3819.55 314.184,3820.54 313.166,3821.16C314.162,3821.04 315.112,3820.77 315.993,3820.37C315.332,3821.38 314.5,3822.27 313.539,3822.98Z",
    style: {
      fill: "rgb(131,147,167)"
    }
  }, _animate9 || (_animate9 = /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1; 1; 1; 1; 1; 1; 1; 1; 0;",
    dur: "3s",
    fill: "freeze",
    begin: "point.begin"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Google--Icon",
    serifId: "Google+ Icon",
    transform: "matrix(0.617613,0,0,0.5975,-108.414,-2058.59)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    d: "M534,3827.76L530.769,3827.76L530.769,3831.06L528.923,3831.06L528.923,3827.76L525.769,3827.76L525.769,3825.83L528.923,3825.83L528.923,3822.44L530.769,3822.44L530.769,3825.83L534,3825.83L534,3827.76ZM520.867,3817.14C521.055,3817.26 521.267,3817.44 521.502,3817.67C521.728,3817.92 521.95,3818.22 522.166,3818.58C522.373,3818.92 522.557,3819.32 522.717,3819.78C522.849,3820.24 522.915,3820.78 522.915,3821.4C522.897,3822.52 522.66,3823.43 522.204,3824.1C521.981,3824.43 521.744,3824.73 521.494,3825.01C521.217,3825.29 520.922,3825.57 520.61,3825.85C520.431,3826.05 520.266,3826.27 520.114,3826.51C519.935,3826.77 519.846,3827.07 519.846,3827.41C519.846,3827.74 519.938,3828.01 520.121,3828.22C520.276,3828.43 520.428,3828.61 520.575,3828.76L521.592,3829.64C522.224,3830.18 522.778,3830.78 523.255,3831.44C523.704,3832.1 523.938,3832.97 523.956,3834.05C523.956,3835.58 523.315,3836.93 522.031,3838.11C520.701,3839.33 518.781,3839.96 516.272,3840C514.172,3839.98 512.604,3839.51 511.568,3838.59C510.522,3837.73 509.999,3836.7 509.999,3835.5C509.999,3834.92 510.17,3834.27 510.51,3833.56C510.84,3832.84 511.437,3832.21 512.302,3831.67C513.273,3831.08 514.293,3830.69 515.362,3830.5C516.421,3830.34 517.3,3830.24 517.999,3830.22C517.783,3829.93 517.59,3829.61 517.421,3829.27C517.224,3828.94 517.125,3828.54 517.125,3828.08C517.125,3827.8 517.163,3827.57 517.238,3827.38C517.304,3827.18 517.365,3827 517.421,3826.84C517.081,3826.88 516.76,3826.9 516.458,3826.9C514.862,3826.88 513.645,3826.35 512.808,3825.32C511.932,3824.35 511.494,3823.23 511.494,3821.95C511.494,3820.4 512.115,3819 513.356,3817.74C514.208,3817 515.094,3816.52 516.013,3816.29C516.923,3816.1 517.775,3816 518.571,3816L524.568,3816L522.716,3817.14L520.867,3817.14ZM516.97,3831.14C516.349,3831.24 515.714,3831.39 515.065,3831.59C514.912,3831.65 514.697,3831.74 514.421,3831.87C514.144,3832 513.862,3832.19 513.576,3832.44C513.299,3832.69 513.065,3833.01 512.874,3833.39C512.654,3833.79 512.545,3834.27 512.545,3834.84C512.545,3835.94 513.022,3836.86 513.977,3837.57C514.884,3838.29 516.125,3838.66 517.7,3838.68C519.113,3838.66 520.192,3838.33 520.937,3837.7C521.662,3837.07 522.025,3836.27 522.025,3835.28C522.025,3834.48 521.777,3833.78 521.281,3833.19C520.755,3832.63 519.934,3831.93 518.817,3831.12C518.626,3831.09 518.402,3831.08 518.144,3831.08C517.991,3831.06 517.6,3831.08 516.97,3831.14ZM519.465,3819.09C519.182,3818.49 518.809,3817.99 518.346,3817.61C517.873,3817.26 517.33,3817.06 516.715,3817.04C515.903,3817.06 515.227,3817.41 514.688,3818.08C514.234,3818.78 514.017,3819.56 514.036,3820.42C514.036,3821.56 514.354,3822.74 514.989,3823.98C515.296,3824.55 515.692,3825.04 516.178,3825.44C516.664,3825.84 517.22,3826.04 517.844,3826.04C518.634,3826.01 519.291,3825.71 519.818,3825.15C520.071,3824.75 520.235,3824.34 520.307,3823.92C520.351,3823.49 520.372,3823.14 520.372,3822.85C520.372,3821.61 520.07,3820.36 519.465,3819.09Z",
    style: {
      fill: "rgb(131,147,167)"
    }
  }, _animate10 || (_animate10 = /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1; 1; 1; 1; 1; 1; 1; 1; 0;",
    dur: "3s",
    fill: "freeze",
    begin: "point.begin"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Facebook-Icon",
    serifId: "Facebook Icon",
    transform: "matrix(0.530044,0,0,0.592346,12.4575,-2039.25)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    d: "M410.156,3840L410.156,3829.02L406.006,3829.02L406.006,3824.82L410.157,3824.82L410.157,3821.65C410.157,3818 412.627,3815.99 416.282,3815.99C418.032,3815.99 419.568,3816.1 420.007,3816.15L420.007,3820.02L417.412,3820.02C415.424,3820.02 415.052,3820.86 415.052,3822.1L415.052,3824.82L419.809,3824.82L419.191,3829.02L415.052,3829.02L415.052,3840L410.156,3840Z",
    style: {
      fill: "rgb(131,147,167)",
      fillRule: "nonzero"
    }
  }, _animate11 || (_animate11 = /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1; 1; 1; 1; 1; 1; 1; 1; 0;",
    dur: "3s",
    fill: "freeze",
    begin: "point.begin"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Pinterest-Icon",
    serifId: "Pinterest Icon",
    transform: "matrix(0.635927,0,0,0.591148,-152.248,-2034.2)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    d: "M631.604,3816C624.555,3816 621,3820.7 621,3824.61C621,3826.98 621.966,3829.09 624.039,3829.88C624.378,3830.01 624.683,3829.88 624.781,3829.53C624.85,3829.29 625.012,3828.68 625.085,3828.43C625.184,3828.08 625.145,3827.96 624.871,3827.66C624.273,3827 623.892,3826.16 623.892,3824.95C623.892,3821.47 626.697,3818.35 631.197,3818.35C635.182,3818.35 637.371,3820.62 637.371,3823.64C637.371,3827.61 635.478,3830.97 632.667,3830.97C631.115,3830.97 629.953,3829.77 630.325,3828.31C630.771,3826.56 631.635,3824.68 631.635,3823.42C631.635,3822.29 630.983,3821.35 629.634,3821.35C628.047,3821.35 626.772,3822.87 626.772,3824.92C626.772,3826.22 627.245,3827.1 627.245,3827.1C627.245,3827.1 625.622,3833.49 625.337,3834.61C624.77,3836.84 625.252,3839.57 625.292,3839.85C625.316,3840.01 625.543,3840.05 625.645,3839.93C625.791,3839.75 627.681,3837.58 628.324,3835.42C628.506,3834.81 629.368,3831.63 629.368,3831.63C629.883,3832.54 631.39,3833.35 632.992,3833.35C637.762,3833.35 640.998,3829.31 640.998,3823.9C640.998,3819.81 637.27,3816 631.604,3816Z",
    style: {
      fill: "rgb(131,147,167)",
      fillRule: "nonzero"
    }
  }, _animate12 || (_animate12 = /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1; 1; 1; 1; 1; 1; 1; 1; 0;",
    dur: "3s",
    fill: "freeze",
    begin: "point.begin"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Standard1",
    serifId: "Standard",
    transform: "matrix(0.604817,0,0,0.604817,214.298,173.109)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.96758,0,0,1.96758,-93.8307,3.61284)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "0px",
    y: "0px",
    style: {
      fontFamily: "'Arial-BoldMT', 'Arial', sans-serif",
      fontWeight: 700,
      fontSize: 12
    }
  }, "Max Mustermann\n                        ", _animate13 || (_animate13 = /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1; 1; 1; 1; 1; 1; 1; 1; 0;",
    dur: "3s",
    fill: "freeze",
    begin: "point.begin"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.96758,0,0,1.96758,-95.7257,62.1992)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "0px",
    y: "0px",
    style: {
      fontFamily: "'Arial-BoldMT', 'Arial', sans-serif",
      fontWeight: 700,
      fontSize: 12
    }
  }, "*************\n                        ", _animate14 || (_animate14 = /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1; 1; 1; 1; 1; 1; 1; 1; 0;",
    dur: "3s",
    fill: "freeze",
    begin: "point.begin"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "smartphone",
    transform: "matrix(0.159683,0,0,0.159683,41.8731,156.093)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-204.593,-204.593)"
  }, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 409.185,
    height: 409.185
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M329.988,36.838L329.988,52.798L79.197,52.798L79.197,36.838C79.197,16.488 95.686,0 116.035,0L293.15,0C313.489,0 329.988,16.488 329.988,36.838Z",
    style: {
      fill: "rgb(178,177,170)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.197,354.187L329.988,354.187L329.988,372.347C329.988,392.696 313.489,409.185 293.15,409.185L116.035,409.185C95.686,409.185 79.197,392.697 79.197,372.347L79.197,354.187Z",
    style: {
      fill: "rgb(178,177,170)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.988,52.798L329.988,354.187L117.366,354.187L298.892,54.14L298.892,52.798L329.988,52.798Z",
    style: {
      fill: "rgb(211,209,193)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.892,52.798L298.892,54.14L117.366,354.187L79.197,354.187L79.197,52.798L298.892,52.798Z",
    style: {
      fill: "rgb(226,224,208)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.593,
    cy: 381.686,
    r: 16.499,
    style: {
      fill: "rgb(150,148,137)"
    }
  })), /*#__PURE__*/React.createElement("g", null, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Medical",
    transform: "matrix(1,0,0,1,5.38869,-1028.59)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0,
    d: "M110.031,1188.34L110.031,1188.39L110.124,1188.39L110.031,1188.34L110.031,1172L119.969,1172L119.969,1188.34L119.876,1188.39L119.969,1188.39L119.969,1188.34L133.17,1180.67L134.03,1180.17L134.527,1181.04L138.502,1187.96L138.999,1188.83L138.138,1189.33L124.937,1197L138.138,1204.67L138.999,1205.17L138.502,1206.04L134.527,1212.96L134.03,1213.83L133.17,1213.33L119.969,1205.66L119.969,1205.61L119.876,1205.61L119.969,1205.66L119.969,1222L110.031,1222L110.031,1205.66L110.124,1205.61L110.031,1205.61L110.031,1205.66L96.83,1213.33L95.97,1213.83L95.473,1212.96L91.498,1206.04L91.001,1205.17L91.862,1204.67L105.063,1197L91.862,1189.33L91.001,1188.83L91.498,1187.96L95.473,1181.04L95.97,1180.17L96.83,1180.67L110.031,1188.34ZM105.063,1197L105.063,1197C105.063,1197 105.063,1197 105.063,1197ZM124.937,1197C124.937,1197 124.937,1197 124.937,1197L124.937,1197Z"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0; 1; 1; 1; 1; 1; 1;",
    dur: "10s",
    begin: "point.begin + 6s"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Medical1",
    serifId: "Medical",
    transform: "matrix(1,0,0,1,61.828,-1028.14)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0,
    d: "M110.031,1188.34L110.031,1188.39L110.124,1188.39L110.031,1188.34L110.031,1172L119.969,1172L119.969,1188.34L119.876,1188.39L119.969,1188.39L119.969,1188.34L133.17,1180.67L134.03,1180.17L134.527,1181.04L138.502,1187.96L138.999,1188.83L138.138,1189.33L124.937,1197L138.138,1204.67L138.999,1205.17L138.502,1206.04L134.527,1212.96L134.03,1213.83L133.17,1213.33L119.969,1205.66L119.969,1205.61L119.876,1205.61L119.969,1205.66L119.969,1222L110.031,1222L110.031,1205.66L110.124,1205.61L110.031,1205.61L110.031,1205.66L96.83,1213.33L95.97,1213.83L95.473,1212.96L91.498,1206.04L91.001,1205.17L91.862,1204.67L105.063,1197L91.862,1189.33L91.001,1188.83L91.498,1187.96L95.473,1181.04L95.97,1180.17L96.83,1180.67L110.031,1188.34ZM105.063,1197L105.063,1197C105.063,1197 105.063,1197 105.063,1197ZM124.937,1197C124.937,1197 124.937,1197 124.937,1197L124.937,1197Z"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0; 1; 1; 1; 1; 1; 1;",
    dur: "10s",
    begin: "point.begin + 6s"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Medical2",
    serifId: "Medical",
    transform: "matrix(1,0,0,1,116.447,-1028.59)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0,
    d: "M110.031,1188.34L110.031,1188.39L110.124,1188.39L110.031,1188.34L110.031,1172L119.969,1172L119.969,1188.34L119.876,1188.39L119.969,1188.39L119.969,1188.34L133.17,1180.67L134.03,1180.17L134.527,1181.04L138.502,1187.96L138.999,1188.83L138.138,1189.33L124.937,1197L138.138,1204.67L138.999,1205.17L138.502,1206.04L134.527,1212.96L134.03,1213.83L133.17,1213.33L119.969,1205.66L119.969,1205.61L119.876,1205.61L119.969,1205.66L119.969,1222L110.031,1222L110.031,1205.66L110.124,1205.61L110.031,1205.61L110.031,1205.66L96.83,1213.33L95.97,1213.83L95.473,1212.96L91.498,1206.04L91.001,1205.17L91.862,1204.67L105.063,1197L91.862,1189.33L91.001,1188.83L91.498,1187.96L95.473,1181.04L95.97,1180.17L96.83,1180.67L110.031,1188.34ZM105.063,1197L105.063,1197C105.063,1197 105.063,1197 105.063,1197ZM124.937,1197C124.937,1197 124.937,1197 124.937,1197L124.937,1197Z"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0; 1; 1; 1; 1; 1; 1;",
    dur: "10s",
    begin: "point.begin + 6s"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Medical3",
    serifId: "Medical",
    transform: "matrix(1,0,0,1,171.521,-1028.59)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0,
    d: "M110.031,1188.34L110.031,1188.39L110.124,1188.39L110.031,1188.34L110.031,1172L119.969,1172L119.969,1188.34L119.876,1188.39L119.969,1188.39L119.969,1188.34L133.17,1180.67L134.03,1180.17L134.527,1181.04L138.502,1187.96L138.999,1188.83L138.138,1189.33L124.937,1197L138.138,1204.67L138.999,1205.17L138.502,1206.04L134.527,1212.96L134.03,1213.83L133.17,1213.33L119.969,1205.66L119.969,1205.61L119.876,1205.61L119.969,1205.66L119.969,1222L110.031,1222L110.031,1205.66L110.124,1205.61L110.031,1205.61L110.031,1205.66L96.83,1213.33L95.97,1213.83L95.473,1212.96L91.498,1206.04L91.001,1205.17L91.862,1204.67L105.063,1197L91.862,1189.33L91.001,1188.83L91.498,1187.96L95.473,1181.04L95.97,1180.17L96.83,1180.67L110.031,1188.34ZM105.063,1197L105.063,1197C105.063,1197 105.063,1197 105.063,1197ZM124.937,1197C124.937,1197 124.937,1197 124.937,1197L124.937,1197Z"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0; 1; 1; 1; 1; 1; 1;",
    dur: "10s",
    begin: "point.begin + 6s"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-23.469,0)"
  }, /*#__PURE__*/React.createElement("text", {
    opacity: 0,
    x: "157.921px",
    y: "114.419px",
    style: {
      fontFamily: "'ArialMT', 'Arial', sans-serif",
      fontSize: 48
    }
  }, "CODE\n                        ", _animate15 || (_animate15 = /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0; 1; 1; 1; 1; 1; 1;",
    dur: "10s",
    begin: "point.begin + 6s"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZweiFaktorAuthentifizierung);
export default __webpack_public_path__ + "static/media/ZweiFaktorAuthentifizierung.0589f35f92d609df12e92d57d75cbaf4.svg";
export { ForwardRef as ReactComponent };